import { useContext, useMemo } from 'react';
import cx from 'classnames';
import useMeasure from 'react-use-measure';
import { Group } from '@visx/group';
import AnnotationContext from "../context/AnnotationContext.js";
import AnchorLine from "./LabelAnchorLine.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyle = {
  display: 'inline-block'
};
export default function HtmlLabel(_ref) {
  let {
    anchorLineStroke = '#222',
    children,
    className,
    containerStyle,
    horizontalAnchor: propsHorizontalAnchor,
    resizeObserverPolyfill,
    showAnchorLine = true,
    verticalAnchor: propsVerticalAnchor,
    x: propsX,
    y: propsY
  } = _ref;
  // we must measure the rendered title + subtitle to compute container height
  const [labelRef, titleBounds] = useMeasure({
    polyfill: resizeObserverPolyfill
  });
  const {
    width,
    height
  } = titleBounds;

  // if props are provided, they take precedence over context
  const {
    x = 0,
    y = 0,
    dx = 0,
    dy = 0
  } = useContext(AnnotationContext);

  // offset container position based on horizontal + vertical anchor
  const horizontalAnchor = propsHorizontalAnchor || (Math.abs(dx) < Math.abs(dy) ? 'middle' : dx > 0 ? 'start' : 'end');
  const verticalAnchor = propsVerticalAnchor || (Math.abs(dx) > Math.abs(dy) ? 'middle' : dy > 0 ? 'start' : 'end');
  const containerCoords = useMemo(() => {
    let adjustedX = propsX == null ? x + dx : propsX;
    let adjustedY = propsY == null ? y + dy : propsY;
    if (horizontalAnchor === 'middle') adjustedX -= width / 2;
    if (horizontalAnchor === 'end') adjustedX -= width;
    if (verticalAnchor === 'middle') adjustedY -= height / 2;
    if (verticalAnchor === 'end') adjustedY -= height;
    return {
      x: adjustedX,
      y: adjustedY
    };
  }, [propsX, x, dx, propsY, y, dy, horizontalAnchor, verticalAnchor, width, height]);
  return /*#__PURE__*/_jsxs(Group, {
    top: containerCoords.y,
    left: containerCoords.x,
    pointerEvents: "none",
    className: cx('visx-annotationlabel', className),
    children: [/*#__PURE__*/_jsx("foreignObject", {
      width: width,
      height: height,
      overflow: "visible",
      children: /*#__PURE__*/_jsx("div", {
        ref: labelRef,
        style: containerStyle ? {
          ...wrapperStyle,
          ...containerStyle
        } : wrapperStyle,
        children: children
      })
    }), showAnchorLine && /*#__PURE__*/_jsx(AnchorLine, {
      anchorLineOrientation: Math.abs(dx) > Math.abs(dy) ? 'vertical' : 'horizontal',
      anchorLineStroke: anchorLineStroke,
      verticalAnchor: verticalAnchor,
      horizontalAnchor: horizontalAnchor,
      width: width,
      height: height
    })]
  });
}